import React, {Fragment} from 'react'
import { useTranslation } from 'react-i18next'
import Seo from '../components/global/Seo'
import StorySlider from '../components/global/sliders/storySlider'
import Cta from '../components/global/CTA'
import Testimonials from '../components/global/testimonials'
import Perks from '../components/index/perks'
import Faq from '../components/global/faq'
import HeroSection from '../components/global/heroSection'
import FeaturedIn from '../components/index/featuredIn';
import TagSliderWave from '../components/global/TagSliderWave';
import SpicinessTiles from '../components/global/SpicinessTiles';
const Index = (props) => {
  const { t, i18n } = useTranslation()
  const { sliders, fantasies, accents } = props.pageContext.data;
  const lang = i18n.language;
  return (
    <>
      <HeroSection
        title={t('root.headerTitle')}
        text={t('root.headerText')}
        buttonText={t('root.getStarted')}
      />
      <Seo
        title={t('root.seoTitle')}
        description={t('root.seoDescription')}
      />
      {sliders.map((slider, index) => (
          <Fragment key={`slider-row-${index}`}>
            {index === 1 && <FeaturedIn/>}
            {index === 3 && <Cta/>}
            {index === 5 && <TagSliderWave showAllLink={`${t('urls.fantasy')}`} tags={fantasies.filter(fantasy => fantasy[lang] !== '').map(fantasy => ({label: fantasy[lang].fantasy, link: `${t('urls.fantasy')}${fantasy[lang].slug}/`}))} title={"Explore Fantasies"}/>}
            {index === 7 && <SpicinessTiles mb={"40px"}/>}
            {index === 8 && ['en', 'es'].includes(lang) && <TagSliderWave showAllLink={`${t('urls.accent')}`} tags={accents.filter(accent => accent.language === lang).map(accent => ({label: accent.accent, link: `${t('urls.accent')}${accent.slug}/`}))} title={"Explore Accents"}/>}
            {index === 9 && <Testimonials/>}
            {index === 13 && <Perks/>}
            {slider.stories.length > 1 && <StorySlider key={index} stories={slider.stories} title={slider.title} subtitle={slider.subtitle} sliderIndex={index} showMoreLink={slider.showMoreLink} type={slider.type}/>}
          </Fragment>
      ))}
      <Faq
        title={t('root.faqSectionTitle')}
        content={t('root.faq', {returnObjects: true})}
      />
    </>
  )
}

export default Index